(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saddle-lookup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

  document.querySelectorAll('[data-saddle-lookup]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-lookup-form]');
    const input = root.querySelector('[data-lookup-input]');
    const button = root.querySelector('[data-lookup-button]');
    const notice = root.querySelector('[data-lookup-notice]');
    const noticeTitle = root.querySelector('[data-lookup-notice-title]');
    const noticeText = root.querySelector('[data-lookup-notice-text]');

    const labels = {
      search: button?.textContent.trim() || '',
      loading: root.querySelector('[data-lookup-loading]')?.textContent.trim() || '',
      notFoundTitle: root.querySelector('[data-lookup-not-found-title]')?.textContent.trim() || '',
      notFoundText: root.querySelector('[data-lookup-not-found-text]')?.textContent.trim() || '',
      errorTitle: root.querySelector('[data-lookup-error-title]')?.textContent.trim() || '',
      errorText: root.querySelector('[data-lookup-error-text]')?.textContent.trim() || ''
    };

    const showNotice = (state, title, text) => {
      if (!notice || !noticeTitle || !noticeText) return;
      notice.dataset.state = state;
      noticeTitle.textContent = title;
      noticeText.textContent = text;
      notice.hidden = false;
    };

    const clearNotice = () => {
      if (!notice) return;
      notice.hidden = true;
      notice.removeAttribute('data-state');
    };

    const setLoading = (loading) => {
      if (!button || !input) return;
      button.disabled = loading;
      input.disabled = loading;
      button.textContent = loading ? labels.loading : labels.search;
    };

    const go = async (value) => {
      const handle = normalize(value);
      if (!handle) {
        input?.focus();
        return;
      }

      clearNotice();
      setLoading(true);

      const target = window.Shopify.routes.root + 'pages/saddle/' + encodeURIComponent(handle);

      try {
        const response = await fetch(target, {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });

        if (response.ok) {
          window.location.assign(target);
          return;
        }

        if (response.status === 404) {
          showNotice('not-found', labels.notFoundTitle, labels.notFoundText);
          input?.focus();
          return;
        }

        showNotice('error', labels.errorTitle, labels.errorText);
      } catch (error) {
        showNotice('error', labels.errorTitle, labels.errorText);
      } finally {
        setLoading(false);
      }
    };

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      go(input?.value);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["streamline-try-on-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('streamline-try-on-v8')) {
    customElements.define('streamline-try-on-v8', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.stage = this.querySelector('[data-stage]');
        this.pad = this.querySelector('.streamline-try-on__pad');
        this.upload = this.querySelector('[data-upload]');
        this.scaleInput = this.querySelector('[data-scale]');
        this.rotationInput = this.querySelector('[data-rotation]');
        this.adjustments = this.querySelector('[data-adjustments]');
        this.resetButton = this.querySelector('[data-reset]');
        this.horse = this.querySelector('.streamline-try-on__horse');
        this.empty = this.querySelector('[data-empty]');
        this.preset = {
          x: Number(this.dataset.padX),
          y: Number(this.dataset.padY),
          scale: Number(this.dataset.padScale),
          rotation: Number(this.dataset.padRotation)
        };
        this.initial = { ...this.preset };
        this.state = { ...this.initial };
        this.objectUrl = null;
        this.isCustom = false;
        this.renderPad();
        this.bindEvents();
      }
      bindEvents() {
        this.upload.addEventListener('change', (event) => this.loadHorse(event));
        this.querySelectorAll('[data-horse-src]').forEach((button) => button.addEventListener('click', () => this.chooseHorse(button)));
        this.querySelectorAll('[data-discipline-choice]').forEach((button) => button.addEventListener('click', () => this.chooseDiscipline(button)));
        this.querySelectorAll('[data-pad-src]').forEach((button) => button.addEventListener('click', () => this.choosePad(button)));
        this.scaleInput.addEventListener('input', () => { this.state.scale = Number(this.scaleInput.value); this.renderPad(); });
        this.rotationInput.addEventListener('input', () => { this.state.rotation = Number(this.rotationInput.value); this.renderPad(); });
        this.querySelectorAll('[data-nudge-x], [data-nudge-y]').forEach((button) => button.addEventListener('click', () => this.nudge(button)));
        this.resetButton.addEventListener('click', () => this.reset());
        if (this.pad) this.pad.addEventListener('pointerdown', (event) => this.startDrag(event));
      }
      ensureHorse() {
        if (this.horse) return;
        this.horse = document.createElement('img');
        this.horse.className = 'streamline-try-on__horse';
        this.stage.prepend(this.horse);
        if (this.empty) this.empty.remove();
      }
      chooseHorse(button) {
        this.ensureHorse();
        this.horse.removeAttribute('srcset');
        this.horse.removeAttribute('sizes');
        this.horse.src = button.dataset.horseSrc;
        this.horse.alt = button.textContent.trim();
        this.isCustom = false;
        this.classList.remove('is-custom');
        this.adjustments.hidden = true;
        this.initial = this.getDisciplinePreset();
        this.state = { ...this.initial };
        this.updateInputs();
        this.renderPad();
        this.querySelectorAll('[data-horse-src]').forEach((item) => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      }
      loadHorse(event) {
        const file = event.target.files[0];
        if (!file) return;
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = URL.createObjectURL(file);
        this.ensureHorse();
        this.horse.removeAttribute('srcset');
        this.horse.removeAttribute('sizes');
        this.horse.src = this.objectUrl;
        this.horse.alt = file.name;
        this.isCustom = true;
        this.classList.add('is-custom');
        this.adjustments.hidden = false;
        this.initial = this.getDisciplinePreset();
        this.state = { ...this.initial };
        this.updateInputs();
        this.renderPad();
        this.querySelectorAll('[data-horse-src]').forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
        requestAnimationFrame(() => this.adjustments.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
      }
      choosePad(button) {
        if (!this.pad) return;
        this.pad.removeAttribute('srcset');
        this.pad.removeAttribute('sizes');
        this.pad.src = button.dataset.padSrc;
        this.querySelectorAll('[data-pad-src]').forEach((item) => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
        this.syncProductColor(button.dataset.colorValue);
      }
      chooseDiscipline(button) {
        const discipline = button.dataset.disciplineChoice;
        this.querySelectorAll('[data-discipline-choice]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        const matchingColors = Array.from(this.querySelectorAll('[data-pad-discipline]')).filter((item) => item.dataset.padDiscipline === discipline);
        this.querySelectorAll('[data-pad-discipline]').forEach((item) => {
          item.hidden = item.dataset.padDiscipline !== discipline;
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        this.initial = this.getDisciplinePreset(button);
        this.state = { ...this.initial };
        this.updateInputs();
        this.renderPad();
        if (matchingColors.length > 0) this.choosePad(matchingColors[0]);
      }
      getDisciplinePreset(button = this.querySelector('[data-discipline-choice].is-active')) {
        if (!button) return { ...this.preset };
        return {
          x: Number(button.dataset.x),
          y: Number(button.dataset.y),
          scale: Number(button.dataset.scale),
          rotation: Number(button.dataset.rotation)
        };
      }
      syncProductColor(colorValue) {
        const productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        if (!productInfo) return;
        const target = Array.from(productInfo.querySelectorAll('input[type="radio"]')).find((input) => input.value.trim().toLowerCase() === colorValue.trim().toLowerCase());
        if (target && !target.checked) target.click();
      }
      startDrag(event) {
        if (!this.isCustom) return;
        event.preventDefault();
        const rect = this.stage.getBoundingClientRect();
        const start = { pointerX: event.clientX, pointerY: event.clientY, x: this.state.x, y: this.state.y };
        this.pad.setPointerCapture(event.pointerId);
        const move = (moveEvent) => {
          this.state.x = Math.min(100, Math.max(0, start.x + ((moveEvent.clientX - start.pointerX) / rect.width) * 100));
          this.state.y = Math.min(100, Math.max(0, start.y + ((moveEvent.clientY - start.pointerY) / rect.height) * 100));
          this.renderPad();
        };
        const stop = () => {
          this.pad.removeEventListener('pointermove', move);
          this.pad.removeEventListener('pointerup', stop);
          this.pad.removeEventListener('pointercancel', stop);
        };
        this.pad.addEventListener('pointermove', move);
        this.pad.addEventListener('pointerup', stop);
        this.pad.addEventListener('pointercancel', stop);
      }
      renderPad() {
        if (!this.pad) return;
        this.pad.style.left = `${this.state.x}%`;
        this.pad.style.top = `${this.state.y}%`;
        this.pad.style.width = `${this.state.scale}%`;
        this.pad.style.transform = `translate(-50%, -50%) rotate(${this.state.rotation}deg)`;
      }
      nudge(button) {
        if (!this.isCustom) return;
        const step = 1.5;
        this.state.x = Math.min(100, Math.max(0, this.state.x + (Number(button.dataset.nudgeX || 0) * step)));
        this.state.y = Math.min(100, Math.max(0, this.state.y + (Number(button.dataset.nudgeY || 0) * step)));
        this.renderPad();
      }
      reset() {
        this.state = { ...this.initial };
        this.updateInputs();
        this.renderPad();
      }
      updateInputs() {
        this.scaleInput.value = this.state.scale;
        this.rotationInput.value = this.state.rotation;
      }
      disconnectedCallback() { if (this.objectUrl) URL.revokeObjectURL(this.objectUrl); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stuebben-lpo-checker"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-stbn-lpo]').forEach((root) => {
    const dataByCountry = {};
    const i18nNode = root.querySelector('[data-stbn-lpo-i18n]');
    let i18n = {};

    try {
      i18n = i18nNode ? JSON.parse(i18nNode.textContent) : {};
    } catch (error) {
      i18n = {};
    }

    root.querySelectorAll('[data-stbn-lpo-rules]').forEach((node) => {
      try {
        dataByCountry[node.dataset.country] = JSON.parse(node.textContent);
      } catch (error) {
      }
    });

    // Preserve the specific restrictions of the new country editions in English.
    const countryDetailsEnglish = {"Ab 115 cm erweiterte Gebisswahl; genaue Sonder-/Hebelverschnallung dieses Produkts ist nicht festgelegt.":"From 115 cm, a wider choice of bits is allowed; the exact special or leverage configuration of this product is not specified.","Als alleinige Unterlegtrense ausgeschlossen; Sperrwirkung auch in der Kandarenkombination nicht eindeutig freigegeben.":"Excluded as a standalone bradoon; the locking action is also not clearly approved in a double bridle.","Anatomisches Mundstück ist grundsätzlich möglich; Höhe/Breite der Zungenfreiheit ist nicht numerisch belegt.":"An anatomical mouthpiece is possible in principle; the port height and width are not documented numerically.","Aufzieh-/Mehr-Ring-/Pelham-/Fahrgebiss ist keine für die Vielseitigkeitsdressur zugelassene Trense.":"A gag, multi-ring, Pelham or driving bit is not an approved snaffle for eventing dressage.","Baucher-Bauform und Oberbaummaß benötigen den Abgleich mit der spezifischen nationalen Freigabe; getrenntes Maß fehlt.":"The Baucher design and upper shank length require comparison with the specific national approval; the separate measurement is missing.","Bei dieser Auswahl sind ausschließlich Gebisse nach §58 Abs.2 Z1–7 zugelassen.":"Only bits listed in §58(2), items 1–7, are allowed for this selection.","Biegsame ungebrochene Kunststofftrense entspricht §58 Abs.2 Z5.":"A flexible, unjointed plastic snaffle corresponds to §58(2), item 5.","D-Ring laut Produkt 85 × 60 mm; Einhaltung des 80-mm-Ringlimits aus D115 muss am tatsächlichen Ring geprüft werden.":"The product lists a D-ring of 85 × 60 mm; compliance with the 80 mm ring limit in D115 must be checked on the actual ring.","D115.3 erlaubt Aufziehgebisse und freie Zügelanbindung; konkrete Sonderbauform/Verschnallung ist noch zu prüfen.":"D115.3 allows gag bits and freedom of rein attachment; this special design and configuration still require checking.","Die Flügel-/Scheibenbauform ist für dieses Land nicht eindeutig anhand der zugelassenen Abbildungen bestätigt.":"The wing or disc design has not been clearly confirmed against this country's approved illustrations.","Die genaue Form und Bewegungsachse des Rollers müssen mit der nationalen Zeichnung abgeglichen werden.":"The exact roller shape and axis of movement must be compared with the national illustration.","Die nationale Jumper-Regel ist weiter gefasst; die vollständige Sonder-/Hebelverschnallung dieses Produkts ist aber nicht festgelegt.":"The national Jumper rule is broader; the complete special or leverage configuration of this product is nevertheless unspecified.","Diese Bauform ersetzt weder die vorgeschriebene Dressurkandare noch eine zulässige Unterlegtrense.":"This design replaces neither the required dressage curb nor an approved bradoon.","Diese Mundstückbauform gehört nicht zu den für diese Auswahl aufgezählten Trensen nach §58 Abs.2 Z1–7.":"This mouthpiece design is outside the snaffles listed for this selection in §58(2), items 1–7.","Diese Prüfung verlangt einfache Trensenzäumung; eine Kandare ist ausgeschlossen.":"This test requires a snaffle bridle; a curb is excluded.","Dokumentierte Stärke 12 mm liegt unter dem Mindestmaß 14 mm.":"The documented thickness of 12 mm is below the 14 mm minimum.","Doppelt gebrochene Trense grundsätzlich möglich; Mittelstück max. 45 mm und ggf. Zungenfreiheit max. 30 mm / mindestens 30 mm Breite sind nicht numerisch belegt.":"A double-jointed snaffle is possible in principle; a centre piece of at most 45 mm and, if applicable, a port at most 30 mm high and at least 30 mm wide are not documented numerically.","Doppelt gebrochene Trense mit Roller entspricht §58 Abs.2 Z6.":"A double-jointed snaffle with a roller corresponds to §58(2), item 6.","EC D115.2.3 schließt Roller-Mundstücke in der Vielseitigkeitsdressur aus.":"EC D115.2.3 excludes roller mouthpieces in eventing dressage.","Einfach gebrochene Trensenbauform mit zugelassenem Seitenteil; dokumentierte Stärke mindestens 12 mm.":"A single-jointed snaffle with an approved cheek design; documented thickness is at least 12 mm.","Elastische Einsätze an der Zügelbefestigung benötigen eine separate Freigabe; außerdem unterscheiden sich Stärkeangaben in Varianten und Größenhilfe.":"Elastic rein-attachment inserts require separate approval; thickness specifications also differ between variants and the size guide.","FEI Eventing erlaubt doppelte Zäumung erst bei 4*/5*; V105–V115 ist keine solche Freigabe.":"FEI Eventing allows a double bridle only at 4*/5*; V105–V115 does not provide that approval.","FEI Eventing verlangt mindestens 12 mm; Stärke ist nicht für alle Varianten gesichert.":"FEI Eventing requires at least 12 mm; thickness is not confirmed for every variant.","Freie Gebisswahl in dieser Phase ersetzt nicht den Abgleich der vollständigen Sonder-/Hebelverschnallung und möglicher Verbote.":"Freedom of bit choice in this phase does not replace checking the complete special or leverage configuration and any prohibitions.","Gebissstärke mindestens 10 mm; zusätzlich fehlen getrennte Hebel-/Mehr-Ring-Maße bzw. Höhe der starren Zungenfreiheit (max. 40 mm).":"Bit thickness is at least 10 mm; separate leverage or multi-ring measurements, or rigid port height (maximum 40 mm), are missing.","Gebrochene Islandkandare entspricht nicht der ungebrochenen Dressurkandare.":"A jointed Icelandic curb does not correspond to an unjointed dressage curb.","Gedrehte Gebisse sind nach SR Ausrüstung 2.2.3 ausdrücklich verboten.":"Twisted bits are expressly prohibited by SR Equipment 2.2.3.","Gedrehtes Mundstück ist für diese Dressurprüfung nicht zugelassen.":"A twisted mouthpiece is not allowed in this dressage test.","Gedrehtes Mundstück ist nicht als glatte zulässige Eventing-Trense nachgewiesen; genaue nationale Modellentscheidung fehlt.":"The twisted mouthpiece has not been shown to be an approved smooth eventing snaffle; the specific national model ruling is missing.","Genaue Zuordnung zu §58 Abs.2 Z1–7 und verwendete Verschnallung sind offen.":"The precise match to §58(2), items 1–7, and the configuration used remain unresolved.","Glatte, einfach/doppelt/mehrfach gebrochene Bauform; dokumentierte Stärke mindestens 10 mm.":"A smooth single-, double- or multiple-jointed design; documented thickness is at least 10 mm.","Golden Wings Trense ausdrücklich aufgeführt.":"The Golden Wings snaffle is expressly listed.","Hanging-Cheek-Trense grundsätzlich möglich; Oberbaum muss höchstens 7 cm sein. Getrenntes Produktmaß fehlt.":"A hanging-cheek snaffle is possible in principle; the upper shank must be no longer than 7 cm. The separate product measurement is missing.","JP111 erlaubt keine pauschale Freigabe der vollständigen Sonderverschnallung aus den Produktdaten; Hebel, Kinnkette und Einsatz prüfen.":"JP111 does not provide blanket approval of the complete special configuration from the product data; check leverage, curb chain and use.","Jugendliche dürfen nach §202 zusätzlich Mehr-Ring-Trense/Pelham nutzen. Bauform, zulässige Verschnallung und bei Ponys Gesamtmaß sind noch zu prüfen.":"Under §202, young riders may additionally use a multi-ring snaffle or Pelham. Design, permitted configuration and, for ponies, total length still require checking.","Kanada schließt sperrende Trensen in der Dressur ausdrücklich aus.":"Canada expressly excludes locking snaffles in dressage.","Kandare nur in vollständiger Kandarenzäumung möglich. Zungenfreiheit und getrennte Ober-/Unterbaummaße fehlen.":"A curb is possible only in a complete double bridle. Port dimensions and separate upper and lower shank measurements are missing.","Kandarenbauform möglich; Zungenfreiheit, Ober- und Unterbaum sowie vollständige Kombination sind nicht vollständig belegt.":"The curb design is possible; port dimensions, upper and lower shanks and the complete combination are not fully documented.","Kandarenzäumung nur bei ausdrücklich zugelassener Dressuraufgabe. Getrennte Hebelmaße, Zungenfreiheit und vollständige Kombination prüfen.":"A double bridle is allowed only for a dressage test that expressly permits it. Check separate shank measurements, port dimensions and the complete combination.","Klassisches einfach/doppelt gebrochenes Mundstück mit losen oder Olivenkopfringen und mindestens 12 mm dokumentierter Stärke.":"A conventional single- or double-jointed mouthpiece with loose or eggbutt rings and a documented thickness of at least 12 mm.","Konventionelle Trense bzw. ausdrücklich zulässiges Aufziehgebiss nach EC G502.":"A conventional snaffle or an expressly permitted gag under EC G502.","Konventionelle Trense bzw. zulässiges Aufziehgebiss für diese Vielseitigkeitsphase.":"A conventional snaffle or permitted gag for this eventing phase.","Konventionelle Trense bzw. zulässiges Aufziehgebiss in dieser Phase.":"A conventional snaffle or permitted gag in this phase.","Konventionelle Trense für nationale Jumper-Prüfungen; JP111 enthält dafür keine Dressur-Gebissliste.":"A conventional snaffle for national Jumper classes; JP111 does not apply a dressage bit list to these classes.","Konventionelle Trense für nationale Pony-Springprüfung.":"A conventional snaffle for a national pony jumping class.","Konventionelle Trense/Aufziehgebiss ist ab 115 cm in der erweiterten nationalen Ausrüstungsregel möglich.":"A conventional snaffle or gag is possible from 115 cm under the broader national equipment rule.","Konventionelle einfach/doppelt gebrochene Trensenbauform; alle dokumentierten Varianten erreichen mindestens 10 mm.":"A conventional single- or double-jointed snaffle; all documented variants are at least 10 mm thick.","Konventionelle einfach/doppelt gebrochene Trensenbauform; alle dokumentierten Varianten erreichen mindestens 12 mm.":"A conventional single- or double-jointed snaffle; all documented variants are at least 12 mm thick.","Konventionelle einfach/doppelt gebrochene Trensenbauform; alle dokumentierten Varianten erreichen mindestens 14 mm.":"A conventional single- or double-jointed snaffle; all documented variants are at least 14 mm thick.","Mehrere Wirkungs-/Verschnallungsarten. Die tatsächlich gewählte Einstellung und Mittelstücklage sind nicht festgelegt.":"Several actions or configurations are possible. The actual setting and centre-piece position are not specified.","Mehrgliedriges Waterford: Abbildungen und Gelenkgrenzen der Eventing-Vorschrift müssen modellgenau abgeglichen werden.":"Multiple-jointed Waterford: the illustrations and joint limits in the eventing rules require comparison with the exact model.","Mindeststärke ist nicht für jede verkaufte Variante belegt.":"The minimum thickness is not documented for every variant sold.","Mundstückstärke ist dokumentiert; die als Ringdurchmesser bezeichnete Größenangabe ist widersprüchlich. Tatsächlichen Ring nach SR 2.2.3 prüfen.":"Mouthpiece thickness is documented; the size described as ring diameter is contradictory. Check the actual ring against SR 2.2.3.","Nationale offene FEI-Aufgabe oder USEF-Qualifikations-/Meisterschaftsprüfung: genaue Zäumungsvorgabe ist aufgaben- und ausschreibungsabhängig.":"A national open FEI test or USEF qualifying or championship test: the precise bridle requirement depends on the test and competition schedule.","Pelham, Aufzieh-, Mehr-Ring- oder Fahrgebiss entspricht hier keiner zulässigen Dressurtrense oder Dressurkandare.":"A Pelham, gag, multi-ring or driving bit does not correspond to an approved dressage snaffle or curb here.","Pony-/Kleinpferde-Springprüfungen schließen die doppelte Kandarenzäumung aus.":"Pony and small-horse jumping classes exclude a double bridle.","Ponyregel: Pelham max. 15 cm und ein Zügel; Pessoa max. 16 cm und höchstens vier Ringe. Tatsächliches Gesamtmaß/Verschnallung prüfen.":"Pony rule: Pelham maximum 15 cm with one rein; Pessoa maximum 16 cm with at most four rings. Check actual total length and configuration.","Ponysonderregel erfordert den Abgleich von Bauform und vollständiger Verschnallung.":"The special pony rule requires checking the design and complete configuration.","Sonderbefestigung bzw. mehrere Verschnallungen: tatsächliche Konfiguration und Maßabgleich sind nicht festgelegt.":"A special attachment or multiple configurations: the actual setup and compliance with measurements are not specified.","Sondermundstück oder Befestigung: genaue Zeichnungszuordnung, Wirkungsart bzw. Maßnachweis fehlt.":"Special mouthpiece or attachment: an exact match to the illustration, action or dimensional evidence is missing.","Sperrende Unterlegtrense ist in dieser Kandarenzäumung nicht freigegeben.":"A locking bradoon is not approved in this double bridle.","Sperrende Unterlegtrense: Einzelverwendung und genaue nationale Freigabe sind gesondert zu prüfen; keine Freigabe als Unterlegtrense.":"Locking bradoon: standalone use and the exact national approval require separate checking; this is not an approval for use as a bradoon.","Sperrendes Mundstück: nationale Vorschrift bzw. genaue Bauformfreigabe ist für dieses Modell nicht vollständig belegt.":"Locking mouthpiece: the national rule or exact design approval is not fully documented for this model.","Stärke bzw. tatsächliches Ringmaß ist nicht für sämtliche Varianten gesichert.":"Thickness or actual ring dimensions are not confirmed for every variant.","Stübben Golden Wings Snaffle ist im USEF Annex A (Mai 2026, S. 42) ausdrücklich nicht zugelassen.":"The Stübben Golden Wings Snaffle is expressly not allowed in USEF Annex A (May 2026, page 42).","Swiss DR 6.10 schließt Unterlegtrensen bei einfacher Trensenzäumung ausdrücklich aus.":"Swiss DR 6.10 expressly excludes bradoons in a snaffle bridle.","Trensenbauform gehört zu §58 Abs.2 Z1–7.":"The snaffle design is included in §58(2), items 1–7.","Trensenbauform ist nach §58 Abs.2 Z1–7 aufgeführt; der vollständige nationale Maß-/Bauformabgleich ist noch nicht abgeschlossen.":"The snaffle design is listed under §58(2), items 1–7; the full national dimensional and construction check is not yet complete.","Ungebrochenes bzw. besonderes Mundstück: Zungenfreiheit, Material/Biegsamkeit oder genaue Zeichnungszuordnung sind nicht vollständig belegt.":"Unjointed or special mouthpiece: port dimensions, material or flexibility, or the precise match to the illustration are not fully documented.","Unterlegtrense als Bestandteil der vorgeschriebenen Kandarenzäumung.":"A bradoon as part of the required double bridle.","Unterlegtrense ist bei Wahl der Kandarenzäumung zulässig.":"A bradoon is permitted when a double bridle is chosen.","Varianten enthalten 12 mm; nur Varianten ab 14 mm sind für diese Auswahl zulässig.":"Variants include 12 mm; only variants of at least 14 mm are allowed for this selection.","Verwendung als Trense möglich; die Freigabe einer Kandarenkombination hängt von der konkreten Dressuraufgabe ab.":"Use as a snaffle is possible; approval of a double-bridle combination depends on the specific dressage test.","Waterford mit mehreren Gelenken entspricht nicht den hier zugelassenen Dressurmundstücken.":"A multiple-jointed Waterford does not correspond to the dressage mouthpieces allowed here.","Bei Knebeltrensen keine Riemen; zugelassene normale Trensenverschnallung verwenden.":"No keepers on full-cheek snaffles; use a normal approved snaffle configuration.","D115.3: korrekt am Gebiss/Zaum befestigte Zügel; keine Zungenfixierung oder schädigenden Zusatzteile.":"D115.3: reins correctly attached to the bit or bridle; no tongue fixation or harmful additions.","Die fehlende Freigabe bzw. Maßangabe wird nicht als Zulassung gewertet.":"Missing approval or dimensional evidence is not treated as permission.","FEI Eventing Tack Art.2.2–2.6; normale Trensenverschnallung, passende Größe und glatte Originaloberfläche.":"FEI Eventing Tack Articles 2.2–2.6; normal snaffle configuration, correct size and a smooth original surface.","FEI Eventing Tack Art.3: Zügel am Gebiss/Zaum befestigen, keine Zungenfixierung oder schädigenden Zusatzteile. Nationale Ausnahmen gelten zusätzlich.":"FEI Eventing Tack Article 3: attach reins to the bit or bridle; no tongue fixation or harmful additions. National exceptions also apply.","Hier als einfache Trense bewerten; eine Kandarenkombination ist nur in ausdrücklich dafür zugelassenen Prüfungen erlaubt.":"Assess as a standalone snaffle here; a double-bridle combination is allowed only in tests that expressly permit it.","JP111 und GR839: korrekt, schadensfrei und konventionell verschnallen. Diese Bewertung gilt nicht für Hunter oder Equitation.":"JP111 and GR839: correct, non-harmful and conventional configuration. This assessment does not apply to Hunter or Equitation.","Keine doppelte Kandarenzäumung; Sonderverschnallung und zusätzliche Einwirkung gesondert prüfen.":"No double bridle; check special configurations and additional actions separately.","Nicht als alleinige Trense einsetzen: Swiss DR 6.10 schließt Unterlegtrensen bei einfacher Trensenzäumung aus. Passende Kandare und Kinnkette erforderlich.":"Do not use as a standalone snaffle: Swiss DR 6.10 excludes bradoons in a snaffle bridle. A matching curb and curb chain are required.","Normale Trensenverschnallung; keine 4-in-1- oder Mehr-Ring-Wirkung.":"Normal snaffle configuration; no 4-in-1 or multi-ring action.","Nur normale Trensenverschnallung; keine Zusatzteile mit Hebelwirkung.":"Normal snaffle configuration only; no additional leverage components.","Nur zusammen mit regelkonformer Kandare, Kinnkette und zwei Zügelpaaren verwenden.":"Use only with a compliant curb, curb chain and two pairs of reins.","Ordnungsgemäße, schadensfreie Verschnallung; Ponysonderregeln gelten zusätzlich.":"Correct, non-harmful configuration; special pony rules also apply.","Passend verschnallen, keine zusätzliche Sperr-/Hebelwirkung. Gebissbewertung gilt für die gewählte nationale Prüfung, nicht automatisch für FEI-Sonderprüfungen.":"Fit correctly, with no additional locking or leverage action. The assessment applies to the selected national class, and does not automatically apply to special FEI classes.","Roller muss frei beweglich und die Oberfläche glatt sein; bei Knebeltrensen keine zusätzlichen Riemen.":"The roller must move freely and the surface must be smooth; no additional keepers on full-cheek snaffles.","SR 2.2.3: Ringmaß 45–100 mm am tatsächlichen Gebiss prüfen. Passform und schadensfreie Originaloberfläche sind erforderlich.":"SR 2.2.3: check a ring dimension of 45–100 mm on the actual bit. Correct fit and a non-harmful original surface are required.","Zügel am Gebiss/Zaum befestigen; schadensfreie passende Verwendung. G502 betrifft Jumpers, nicht Hunter/Equitation.":"Attach reins to the bit or bridle; use must be correctly fitted and non-harmful. G502 concerns Jumpers, not Hunter or Equitation.","Diese Länderfassung ist abgelaufen. Aktuelle Regelversion vor dem Einsatz prüfen.":"This country edition has expired. Check the current rule version before use."};
    const englishCountryDetail = (value) => {
      if (!value) return '';
      if (countryDetailsEnglish[value]) return countryDetailsEnglish[value];
      const separator = value.indexOf(': ');
      if (separator !== -1) {
        const body = value.slice(separator + 2);
        if (countryDetailsEnglish[body]) return value.slice(0, separator + 2) + countryDetailsEnglish[body];
      }
      return value;
    };

    const country = root.querySelector('[data-stbn-country]');
    const discipline = root.querySelector('[data-stbn-discipline]');
    const divisionField = root.querySelector('[data-stbn-division-field]');
    const division = root.querySelector('[data-stbn-division]');
    const classSelect = root.querySelector('[data-stbn-class]');
    const phaseField = root.querySelector('[data-stbn-phase-field]');
    const phase = root.querySelector('[data-stbn-phase]');
    const selectedPhaseRule = (rule) => rule?.phases ? (rule.phases[phase.value] || null) : rule;
    const countryNote = root.querySelector('[data-stbn-country-note]');
    const result = root.querySelector('[data-stbn-result]');
    const status = root.querySelector('[data-stbn-status]');

    const taxonomy = {
      NL: {
        Jumping: {
          'Paard': ['0,60 m', '0,70 m', '0,80 m', '0,90 m', '1,00 m', '1,05 m', '1,10 m', '1,15 m', '1,20 m', '1,25 m', '1,30 m', '1,35 m', '1,40 m', '1,45 m', '1,50 m'],
          'Pony A/B': ['0,50 m', '0,60 m', '0,70 m'],
          'Pony C': ['0,60 m', '0,70 m', '0,80 m', '0,90 m', '1,00 m'],
          'Pony D/E': ['0,70 m', '0,80 m', '0,90 m', '1,00 m', '1,10 m', '1,20 m', '1,30 m']
        },
        Dressage: {
          'Paard': ['BB', 'B', 'L1', 'L2', 'M1', 'M2', 'Z1', 'Z2', 'ZZ-Licht', 'ZZ-Zwaar', 'Prix St. Georges', 'Intermediaire I', 'Intermediaire A', 'Intermediaire B', 'Intermediaire II', 'Grand Prix 16-25', 'Grand Prix', 'Grand Prix Special'],
          'Pony': ['BB', 'B', 'L1', 'L2', 'M1', 'M2', 'Z1', 'Z2']
        },
        Eventing: {
          'Paard': ['B-intro', 'B', 'L', 'M', 'Z'],
          'Pony A/B': ['B'],
          'Pony C/D/E': ['B-intro', 'B', 'L', 'M', 'Z']
        }
      },
      UK: {
        Jumping: {
          'Club': ['Junior/Senior 60 cm', 'Junior/Senior 70 cm', 'Junior/Senior 80 cm', 'Junior/Senior 90 cm'],
          'Junior': ['Pony Intro 70 cm Open', 'Pony British Novice / 80 cm Open', 'Pony Discovery / 90 cm Open', 'Pony Newcomers / 1,00 m Open', 'Pony Foxhunter / 1,10 m Open', 'Junior 1,10 m Open', 'Junior 1,15 m Open', 'Junior 1,20 m Open'],
          'Senior': ['British Novice / 90 cm Open', 'Discovery / 1,00 m Open', 'Newcomers / 1,10 m Open', '1,15 m Open', 'Foxhunter / 1,20 m Open', '1,25 m Open', 'National 1,30 m Open', '1,35 m Open', '1,40 m Grand Prix']
        },
        Dressage: {
          'British Dressage': ['Intro', 'Prelim', 'Novice', 'Elementary', 'Medium', 'Advanced Medium', 'Prix St Georges', 'Intermediate I', 'Intermediate II', 'Grand Prix']
        },
        Eventing: {
          'National': ['BE80', 'BE90', 'BE100', 'BE100 Plus', 'BE105', 'Novice', 'Intermediate Novice', 'Intermediate', 'Advanced Intermediate', 'Advanced'],
          'International': ['CCI1*-Intro', 'CCI2*-S', 'CCI2*-L', 'CCI3*-S', 'CCI3*-L', 'CCI4*-S', 'CCI4*-L', 'CCI5*-L']
        }
      },
      SE: {
        Jumping: {
          'Häst': ['0,90 m', '0,95 m', '1,00 m', '1,05 m', '1,10 m', '1,15 m', '1,20 m', '1,25 m', '1,30 m', '1,35 m', '1,40 m', '1,45 m', '1,50 m', '1,55 m', '1,60 m'],
          'Unghäst': ['4-åriga hästar'],
          'Ponny': ['Lätt D', 'Lätt D +5 cm', 'Lätt C', 'Lätt C +5 cm', 'Lätt B', 'Lätt B +5 cm', 'Lätt A', 'Lätt A +5 cm', 'Medelsvår B', 'Medelsvår B +5 cm', 'Medelsvår A', 'Medelsvår A +5 cm']
        },
        Dressage: {
          'Häst': ['LC', 'LB', 'LA', 'Msv C', 'Msv B', 'Msv A', 'Prix St Georges', 'Intermediaire I', 'Grand Prix'],
          'Ponny': ['LC', 'LB', 'LA']
        },
        Eventing: {
          'Häst': ['H80', 'H90', 'H100', 'H2*', 'H3*', 'H4*'],
          'Ponny': ['P60', 'P70', 'P80', 'P90', 'P1*', 'P2*']
        }
      }
    };

    const ruleAliases = {
      FR: {
        Jumping: {
          'As Poney': {
            'As Poney 2C': 'As Poney 2C/2D',
            'As Poney 2D': 'As Poney 2C/2D'
          }
        },
        Eventing: {
          'As Poney': {
            'As Poney 2C': 'As Poney 2',
            'As Poney 2D': 'As Poney 2'
          }
        }
      }
    };

    let activeData = dataByCountry[country.value];

    const getDisciplineData = () => activeData?.rules?.[discipline.value] || {};
    const getTaxonomyData = () => taxonomy[country.value]?.[discipline.value] || null;
    const usesDivisions = () => Boolean(getTaxonomyData() || getDisciplineData().divisions);

    const getDivisionNames = () => {
      const taxonomyData = getTaxonomyData();
      if (taxonomyData) return Object.keys(taxonomyData);
      return Object.keys(getDisciplineData().divisions || {});
    };

    const getClassNames = () => {
      const taxonomyData = getTaxonomyData();
      if (taxonomyData) return taxonomyData[division.value] || [];

      const disciplineData = getDisciplineData();
      if (disciplineData.divisions) {
        return Object.keys(disciplineData.divisions?.[division.value]?.classes || {});
      }

      return Object.keys(disciplineData || {});
    };

    const refillDivisions = () => {
      if (!usesDivisions()) {
        divisionField.hidden = true;
        division.replaceChildren();
        return;
      }

      divisionField.hidden = false;
      const names = getDivisionNames();
      division.replaceChildren(...names.map((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        return option;
      }));
    };

    const refillClasses = () => {
      const names = getClassNames();
      classSelect.replaceChildren(...names.map((name) => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        return option;
      }));
    };

    const getExactRule = () => {
      const disciplineData = getDisciplineData();

      if (usesDivisions()) {
        const classes = disciplineData.divisions?.[division.value]?.classes || {};
        const directRule = classes[classSelect.value];
        if (directRule) return selectedPhaseRule(directRule);

        const alias = ruleAliases[country.value]?.[discipline.value]?.[division.value]?.[classSelect.value];
        if (alias && classes[alias]) return selectedPhaseRule(classes[alias]);

        return null;
      }

      return disciplineData?.[classSelect.value] || null;
    };

    const getReferenceRule = () => {
      const disciplineData = getDisciplineData();

      if (disciplineData.divisions) {
        const preferredClasses = disciplineData.divisions?.[division.value]?.classes || {};
        const preferredRule = Object.values(preferredClasses)[0];
        if (preferredRule) return selectedPhaseRule(preferredRule);

        for (const divisionData of Object.values(disciplineData.divisions)) {
          const candidate = Object.values(divisionData.classes || {})[0];
          if (candidate) return selectedPhaseRule(candidate);
        }
      }

      return Object.values(disciplineData || {}).find((candidate) => candidate && typeof candidate === 'object') || null;
    };

    const getRule = () => {
      // Expired national editions must not continue to show old approvals.
      if (activeData?.valid_until && new Date().toISOString().slice(0, 10) > activeData.valid_until) {
        const reference = getReferenceRule();
        return {
          status: 'orange',
          label: i18n.status?.orange || 'Bedingt / prüfen',
          reason: 'Diese Länderfassung ist abgelaufen. Aktuelle Regelversion vor dem Einsatz prüfen.',
          note: activeData.future_change || '',
          authority: activeData.authority || '',
          source: reference?.source || '',
          checked: activeData.checked || ''
        };
      }

      const exactRule = getExactRule();
      if (exactRule) return exactRule;

      const reference = getReferenceRule();
      if (!reference) return null;

      return {
        status: 'orange',
        label: i18n.status?.orange || 'Bedingt / prüfen',
        reason: i18n.fallback_reason || '',
        note: i18n.fallback_note || '',
        authority: reference.authority || activeData?.authority || '',
        source: reference.source || '',
        checked: reference.checked || '',
        localizedFallback: true
      };
    };

    const render = () => {
      const rule = getRule();

      if (!rule) {
        result.hidden = true;
        return;
      }

      result.hidden = false;
      status.dataset.status = rule.status || '';

      const translatedLabel = i18n.status?.[rule.status] || rule.label || '';
      const useStoredDetails = i18n.locale === 'de' && !rule.localizedFallback;
      const useCountryEnglish = i18n.locale === 'en' && ['CH', 'AT', 'US', 'CA'].includes(country.value) && !rule.localizedFallback;
      const storedUKDetails = country.value === 'UK' && activeData?.version >= 19 && !rule.localizedFallback;
      const ukLanguageSuffix = i18n.locale === 'fr' ? '_fr' : i18n.locale === 'de' ? '' : '_en';
      const translatedReason = storedUKDetails && rule['reason' + ukLanguageSuffix] ? rule['reason' + ukLanguageSuffix] : useCountryEnglish ? englishCountryDetail(rule.reason) : useStoredDetails ? (rule.reason || '') : (i18n.reason?.[rule.status] || rule.reason || '');
      const translatedNote = storedUKDetails && rule['note' + ukLanguageSuffix] ? rule['note' + ukLanguageSuffix] : useCountryEnglish ? englishCountryDetail(rule.note) : useStoredDetails ? (rule.note || '') : (i18n.note?.[rule.status] || rule.note || '');

      root.querySelector('[data-stbn-label]').textContent = translatedLabel;
      root.querySelector('[data-stbn-reason]').textContent = translatedReason;
      root.querySelector('[data-stbn-note]').textContent = translatedNote;
      const authority = rule.authority || activeData?.authority || '';
      const checkedLabel = i18n.checked || 'Stand';
      root.querySelector('[data-stbn-checked]').textContent = authority + (authority ? ' · ' : '') + checkedLabel + ' ' + (rule.checked || '');

      const source = root.querySelector('[data-stbn-source]');
      source.href = rule.source || '#';
    };

    const refreshDiscipline = () => {
      phaseField.hidden = !(country.value === 'UK' && discipline.value === 'Eventing' && activeData?.version >= 19);
      phase.disabled = phaseField.hidden;
      refillDivisions();
      refillClasses();
      render();
    };

    const updateCountry = () => {
      activeData = dataByCountry[country.value];
      const hasData = Boolean(activeData);

      discipline.disabled = !hasData;
      division.disabled = !hasData;
      classSelect.disabled = !hasData;
      countryNote.hidden = hasData;

      if (!hasData) {
        phaseField.hidden = true;
        phase.disabled = true;
        result.hidden = true;
        divisionField.hidden = true;
        division.replaceChildren();
        classSelect.replaceChildren();
        return;
      }

      refreshDiscipline();
    };

    country.addEventListener('change', updateCountry);
    discipline.addEventListener('change', refreshDiscipline);
    division.addEventListener('change', () => {
      refillClasses();
      render();
    });
    classSelect.addEventListener('change', render);
    phase.addEventListener('change', render);

    updateCountry();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
